import Canvas from "diagram-js/lib/core/Canvas";

export class CustomCanvas extends Canvas {

  constructor(private config, private eventBus, private graphicsFactory,private elementRegistry) {
    super(config, eventBus, graphicsFactory, elementRegistry);
    // No need to register, base class already did
  }
  addConnection(connection, parent, parentIndex){
    super.addConnection(connection,parent,0);
  }

}
